import {Form} from '../../../stores/Form';
import {ItemType, LocationType, MarkerType, RouteType} from '../types';

// Define generic action type
type Action<T, P = undefined> = {
    type: T;
    payload?: P;
};

// Define advanced delivery action types

export enum ActionTypes {
    OPEN_ADP = 'OPEN_ADP',
    CLOSE_ADP = 'CLOSE_ADP',
    SET_SELECTED_MARKERS = 'SET_SELECTED_MARKERS',
    SET_ROUTES = 'SET_ROUTES',
    SET_ROUTE_LOCATIONS = 'SET_ROUTE_LOCATIONS',
    SET_ROUTE_LOCATIONS_AND_FORM = 'SET_ROUTE_LOCATIONS_AND_FORM',
    SET_ROUTE_COLLAPSABLE_OPEN = 'SET_ROUTE_COLLAPSABLE_OPEN',
    SET_LOCATION_SUBFORM_OPEN = 'SET_LOCATION_SUBFORM_OPEN',
    SET_ROUTE_LOCATION_FORM = 'SET_ROUTE_LOCATION_FORM',
    SET_ROUTE_LOCATION_FORM_LOADING = 'SET_ROUTE_LOCATION_FORM_LOADING',
    SET_ROUTE_LOCATION_FORM_RELOAD = 'SET_ROUTE_LOCATION_FORM_RELOAD',
    SET_LOCATION_ITEMS = 'SET_LOCATION_ITEMS',
    SET_ROUTE_COLOR = 'SET_ROUTE_COLOR',
    SET_LOCATION_ITEM_FORM = 'SET_LOCATION_ITEM_FORM',
    TOGGLE_SHOW_ROUTE = 'TOGGLE_SHOW_ROUTE',
    SET_PLANING_FORM = 'SET_PLANING_FORM',
    SET_ROUTES_FORM = 'SET_ROUTES_FORM',
    SET_SHOW_PLANNED_LOCATIONS = 'SET_SHOW_PLANNED_LOCATIONS',
    SELECTED_LOCATIONS = 'SELECTED_LOCATIONS',
    SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS',
    TOGGLE_ROUTE_SELECT = 'TOGGLE_ROUTE_SELECT',
    UNSELECT_ALL_ROUTES = 'UNSELECT_ALL_ROUTES',
    SET_DISPLAYED_ROUTES = 'SET_DISPLAYED_ROUTES'
}

type SetSelectedLocations = Action<ActionTypes.SET_SELECTED_LOCATIONS, number[]>;
type SetShowPlannedLocations = Action<ActionTypes.SET_SHOW_PLANNED_LOCATIONS, boolean>;
type SetPlaningForm = Action<ActionTypes.SET_PLANING_FORM, Form>;
type SetRoutesForm = Action<ActionTypes.SET_ROUTES_FORM, Form>;
type OpenADvDAction = Action<ActionTypes.OPEN_ADP>;
type CloseADvDAction = Action<ActionTypes.CLOSE_ADP>;
type SetSelectedMarkerAction = Action<ActionTypes.SET_SELECTED_MARKERS, MarkerType[]>;
type SetRoutesAction = Action<ActionTypes.SET_ROUTES, {routes: RouteType[]; showAll: boolean}>;
type SetRouteLocationsAction = Action<
    ActionTypes.SET_ROUTE_LOCATIONS,
    {locations: LocationType[]; routeId: number}
>;
type SetRouteLocationsAndFormAction = Action<
    ActionTypes.SET_ROUTE_LOCATIONS_AND_FORM,
    {locations: LocationType[]; form: Form; routeId: number}
>;
type SetIsCollapsableRouteOpen = Action<
    ActionTypes.SET_ROUTE_COLLAPSABLE_OPEN,
    {isCollapsableOpen: boolean; routeId: number}
>;
type SetRouteLocationFormReload = Action<
    ActionTypes.SET_ROUTE_LOCATION_FORM_RELOAD,
    {routeId: number; value: boolean}
>;
type SetLocationSubformOpen = Action<
    ActionTypes.SET_LOCATION_SUBFORM_OPEN,
    {locationSubformOpen: boolean; routeId: number}
>;
type SetRouteLocationFormAction = Action<
    ActionTypes.SET_ROUTE_LOCATION_FORM,
    {form: Form; routeId: number}
>;
type SetRouteLocationFormLoadingAction = Action<
    ActionTypes.SET_ROUTE_LOCATION_FORM_LOADING,
    {loading: boolean; routeId: number}
>;
type SetLocationItemFormAction = Action<
    ActionTypes.SET_LOCATION_ITEM_FORM,
    {form: Form; routeId: number; locationId: number}
>;
type SetLocationItemsAction = Action<
    ActionTypes.SET_LOCATION_ITEMS,
    {locationId: number; routeId: number; items: ItemType[]}
>;
type SetRouteColorAction = Action<ActionTypes.SET_ROUTE_COLOR, {routeId: number; color: string}>;
type ToggleShowRouteAction = Action<ActionTypes.TOGGLE_SHOW_ROUTE, RouteType[]>;

type ToggleRouteSelectAction = Action<ActionTypes.TOGGLE_ROUTE_SELECT, RouteType[]>;

type UnselectAllRoutesAction = Action<ActionTypes.UNSELECT_ALL_ROUTES, RouteType[]>;

type SetDisplayedRoutesAction = Action<
    ActionTypes.SET_DISPLAYED_ROUTES,
    {routesToDisplay: RouteType[]; showAll: boolean}
>;

export type AdvancedDeliveryAction =
    | SetSelectedLocations
    | SetShowPlannedLocations
    | SetRoutesForm
    | SetPlaningForm
    | OpenADvDAction
    | CloseADvDAction
    | SetSelectedMarkerAction
    | SetRoutesAction
    | ToggleShowRouteAction
    | SetRouteLocationsAction
    | SetLocationItemsAction
    | SetRouteLocationFormAction
    | SetLocationItemFormAction
    | SetRouteLocationFormLoadingAction
    | SetIsCollapsableRouteOpen
    | ToggleRouteSelectAction
    | UnselectAllRoutesAction
    | SetLocationSubformOpen
    | SetRouteColorAction
    | SetRouteLocationFormReload
    | SetDisplayedRoutesAction
    | SetRouteLocationsAndFormAction;
